export const DEFAULT_PAGE_ID = 'index';
// Matching https://tiny.amazon.com/y433oanm/codeamazpackKatablobc0fasrc
// Except for the '/' since we consider only the top-level page/route
const PAGE_ID_PATTERN = /^[A-Za-z0-9.:@_-]+/i;
/**
 * Tries to get the top level route by parsing it from window.location.hash for monitoring.
 * location.hash should look like #/, #/contact-landing-page/, #/contact-landing-page/route,
 * #/contact-landing-page?param1=value1&param2=value2, etc.
 * pageId from all these cases except the first one should be contact-landing-page.
 * @return {string} top level page/route if, defaults to 'index' on any error
 * or invalid route string. Check unit tests for covered scenarios
 */
export function getRoute() {
    // TODO: This function will also be used to replace the getCurrentPath function
    // in CSC-UI-Module-Logging in this story: https://sim.amazon.com/issues/caracara-17910.
    let route = DEFAULT_PAGE_ID;
    if (window && window.location) {
        const hash = window.location.hash;
        if (hash) {
            const hashParts = hash.split('/');
            if (hashParts.length > 1) {
                const match = hashParts[1].match(PAGE_ID_PATTERN);
                if (match && match.length > 0) {
                    route = match[0].toLowerCase();
                }
            }
        }
    }
    return route;
}
//# sourceMappingURL=GetRoute.js.map